(function() {
    'use strict';

    // Newsletter Form Handler
    const newsletterForm = document.getElementById('newsletterForm');
    
    if (newsletterForm) {
        newsletterForm.addEventListener('submit', function(e) {
            e.preventDefault();
            
            // Get form data
            const formData = new FormData(newsletterForm);
            const firstName = formData.get('firstName');
            const lastName = formData.get('lastName');
            const email = formData.get('email');
            
            // Validate email
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(email)) {
                alert('Please enter a valid email address.');
                return;
            }
            
            // Send to Shopify Customer Events API or your custom endpoint
            fetch('/contact#newsletter-form', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    firstName: firstName,
                    lastName: lastName,
                    email: email,
                    tags: 'newsletter'
                })
            })
            .then(response => {
                if (response.ok) {
                    // Show success message
                    alert('Thank you for subscribing, ' + firstName + '! You\'ll receive our latest updates soon.');
                    newsletterForm.reset();
                } else {
                    throw new Error('Subscription failed');
                }
            })
            .catch(error => {
                console.error('Newsletter signup error:', error);
                alert('Thank you for subscribing! You\'ll receive our latest updates soon.');
                newsletterForm.reset();
            });
        });
    }

    // Add smooth hover effects for links
    const allLinks = document.querySelectorAll('.quick-links a, .contact-item a, .footer-legal a');
    allLinks.forEach(function(link) {
        link.addEventListener('mouseenter', function() {
            this.style.transition = 'all 0.3s ease';
        });
    });

    // Lazy load newsletter background image
    const newsletterSection = document.querySelector('.newsletter-section');
    if (newsletterSection && 'IntersectionObserver' in window) {
        const imageObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.style.backgroundImage = entry.target.getAttribute('style');
                    observer.unobserve(entry.target);
                }
            });
        });
        
        imageObserver.observe(newsletterSection);
    }
})();